<template>
  <div class="media-list d-flex media-list__thumbnails" v-loading="isBusy">
    <div class="media__item text-center" v-for="item in getMediaList">
      <component
          :key="item.id"
          :item="item"
          v-bind:is="getMediaComponent(item)"
          @open-media-dialog="openDialog"
      ></component>
      <a class="media__item-hide" @click="toggleHide(item)" v-if="canToggleHide(item) && isInbound" v-text="getButtonText(item)"></a>
    </div>
  </div>
</template>

<script>
import ImageComponent from './media-types/image';
import VideoComponent from './media-types/video';
import PdfComponent from './media-types/pdf';
import eventBus from '../../event-bus';

export default {
  components: {
    'image-component': ImageComponent,
    'video-component': VideoComponent,
    'pdf-component': PdfComponent,
  },

  props: {
    media: Array,
    isInbound: Boolean,
  },

  data() {
    return {
      isBusy: false,
    };
  },

  computed: {
    /**
     * @return {Object}
     */
    getMediaList() {
      return this.media;
    }
  },

  methods: {
    /**
     * @return {String}
     */
    getMediaComponent(item) {
      let mime =  _.get(item, 'model.mime_type');
      if (RegExp('^video\/', 'i').test(mime)) {
        return 'video-component';
      }

      if (RegExp('^application\/pdf', 'i').test(mime)) {
        return 'pdf-component';
      }

      return 'image-component';
    },

    /**
     * @param {Object} item
     * @return {Boolean}
     */
    canToggleHide(item) {
      return  _.get(item, 'canToggleHide', false);
    },

    /**
     * @param {Object} item
     * @return {String}
     */
    getButtonText(item) {
      let text = 'Hide';

      if (_.get(item, 'model.is_hidden') === true) {
        text = 'Show';
      }

      return text;
    },

    /**
     * @param {Object} item
     * @return {undefined}
     */
    toggleHide(item) {
      this.isBusy = true;

      const url = _.get(item, 'toggleHideUrl');

      return axios.post(url)
          .then(this.storeSuccess)
          .catch(this.handleErrorResponse)
          .then((isBusy = false) => {
            this.isBusy = isBusy;
          });
    },

    /**
     * @param {Object} data
     * @param {String} message
     * @return {undefined}
     */
    storeSuccess({data: {data, message}}) {
      _.isString(message) && this.$message.success(message);

      this.replaceModel(data);
    },

    /**
     * @param {Object} data
     */
    replaceModel(data) {
      let exist = _.findIndex(this.media, function (item) {
        return item.model.id === _.get(data, 'model.id');
      });

      if (exist >= 0) {
        this.media.splice(exist, 1);
        this.media.unshift(data);
      }
    },

    /**
     * @param {Object} response
     * @return {boolean}
     */
    handleErrorResponse({response: {data}}) {
      const {message} = data || {};
      if (message && _.isString(message)) {
        this.$message.error(message);
      }

      return false;
    },

    /**
     * @param {object} payload
     * @event show-media-show-dialog
     */
    openDialog(payload) {
      eventBus.$emit('show-media-show-dialog', payload);
    },
  },
}
</script>
